<template>
    <div id="app">
        <error-page></error-page>
    </div>
</template>

<script type="text/babel">
import ErrorPage from '@/pages/Error'
    export default {
        name: 'err',
        data() {
            return {
                loaded: true
            }
        },
        components: {
            "error-page": ErrorPage
        }
    }
</script>

<style>
    @import './assets/base.css';
    @import './assets/reset.css';

    body a {
        text-decoration: none;
    }

    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        background-color: #eee;
        color: #333;
        height: 100vh;
        width: 100%;
        overflow: hidden;
    }

    .mint-spinner-snake {
        margin: auto;
    }

    .is-dropped {
        margin-bottom: 55px;
    }
    .tab-menu{
        margin-bottom: 10px;
    }
    .more-menu{
        width: 20%;
        margin-top: 10px;
        line-height: 20px;
        text-align: center;
        position: absolute;
        background: #fff;
        right: 0;
        z-index: 100;
    }
    .badge{
        color: #fff;
        background-color:#3dcd57;
        border-radius: 18px;
        font-size: 12px;
        padding: 2px;
        min-width: 18px;
        line-height: 14px;
        text-align: center;
        display: inline-block;
    }
    /* custom button */

    .common-btn {
        font-size: 18px;
        line-height: 50px;
        border-radius: 5px;
        text-align: center;
    }
    .text-left{
        text-align: left !important;
    }
    .text-center {
        text-align: center !important;
    }
    .text-right{
        text-align: right !important;
    }

    .common-title .icon-more{
        float: right;
        margin-right: 10px;
        line-height: 40px;
    }
    .dot-dash-dot {
        border-bottom: 1px dashed #dfdfdf;
        height: 1px;
        line-height: 1;
        font-size: 1px;
        margin: 10px -10px;
        clear: both;
        position: relative;
    }


    /* scroll to top */
    .to-top {
        position: fixed;
        right: 33px;
        bottom: 90px;
        width: 33px;
        height: 33px;
        background: url(./assets/img/icon_top.png) center/100%;
    }

    /*search*/

    .search-wrapper {
        padding: 10px;
        position: relative;
    }

    .search-input {
        display: block;
        border-radius: 5px;
        border: 1px solid #ccc;
        padding: 10px 30px;
        height: 30px;
        width: 100%;
        background: #fff;
    }

    .search-button {
        position: absolute;
        top: 13px;
        right: 16px;
        width: 24px;
        height: 24px;
        background: url(./assets/img/icon-search.png) center/100% no-repeat;
        border: 2px solid transparent;
    }
    /*custom progress bar*/
    .mt-progress-progress {
        border-radius: 5px;
    }
    .alter-process .mt-progress {
        flex-grow: 1;
        font-weight: bold;
        color: #51da92;
    }

    .alter-process .mt-progress-progress {
        background-color: #51da92;
    }

    .mint-toast {
        z-index: 3000;
    }

    .all-loaded {
        text-align: center;
        padding-bottom: 10px;
        font-size: 12px;
    }
    /* restrict custom image width */

    .detail-wrap img {
        max-width: 100%;
    }

    .pre-text {
        white-space: pre-wrap;
    }
    /* custom radio */

    .on .mint-radio-core {
        border: 6px solid #0796ff;
    }
    /* header top space */


    .mint-header.is-fixed+div {
        margin-top: 50px;
    }
    /* no-record picture */

    .no-record {
        /*background: url(./assets/img/no-record.png) center/100% no-repeat;*/
        /*width: 142px;*/
        /*height: 128px;*/
        /*margin: auto;*/
        display: flex;
        justify-content: center;
        align-items: center;
        color: #999;
    }
    /* back button enhencement */

    .mint-header-button>a {
        color: inherit;
        border: 5px solid transparent;
    }

    .mintui-back:before,
    .mintui-search:before {
        font-size: 20px;
    }

    [v-cloak]{
        visibility:hidden;
    }
    .hide{
        display: none;
    }
    .preview-file{
        color: inherit;
        text-decoration: underline;
        padding-bottom: 10px;
        display: block;
    }
    /* start of list style */
    .sorted{
        width: 12px;
        height: 11px;
        display: inline-block;
        background:url(./assets/img/icon_arrow.png) center/100% no-repeat;
        margin-left: 5px;
    }
    .sort-asc{
        transform: rotate(180deg);
    }
    .scroll-wrapper{
        overflow-y: scroll;
        -webkit-overflow-scrolling:touch;
        /* overflow-scrolling: touch; */
    }
    .table-list{
        color: #333;
        padding: 0;
        font-size: 14px;
    }
    /*.table-list-li{*/
    /*padding: 4px 1em;*/
    /*font-size: 13px;*/
    /*line-height: 40px;*/
    /*overflow: hidden;*/
    /*background-color: #fff;*/
    /*border-bottom: 1px solid #e8e8e8;*/
    /*}*/
    .table-list-li{
        display: flex;
        justify-content: space-between;
        padding: 4px 1em;
        font-size: 13px;
        line-height: 40px;
        height: 49px;
        background-color: #fff;
        border-bottom: 1px solid #e8e8e8;
    }
    .table-list-header{
        font-size: 14px;
        /*font-weight: bold;*/
        background-color: #effff2;
    }
    .table-list-li .item-head,
    .table-list-li .item-body,
    .table-list-li .item-foot{
        /*float: left;*/
        /*height: 40px;*/
        line-height:20px;
        display: -webkit-box;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-line-clamp: 2;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /*! autoprefixer: off */
        align-self: center;
    }
    .item-head{
        width: 42%;
        text-align: left;
    }
    .item-body{
        width: 25%;
        /* text-align: center; */
    }
    .item-foot{
        width: 33%;
        text-align: right;
    }
    .table-list-header .item-body{
        text-align: center;
    }
    .strict2{
        line-height:20px;
        color: #3dcd57;
        display: -webkit-box;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-line-clamp: 2;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /*! autoprefixer: off */
        align-self: center;
    }
    .item-icon{
        padding-right: 15px;
        background: url(./assets/img/icon_time.png) right 2px/12px no-repeat;
    }
    .right-icon{
        float:right;
        max-width: 16px;
        line-height: 20px;
    }
    .right-icon i{
        width: 15px;
        height: 15px;
        display: inline-block;
    }
    .icon-time{
        background: url(./assets/img/icon_time.png) right 2px/12px no-repeat;
    }
    .icon-label{
        background: url(./assets/img/icon_label.png) right 2px/12px no-repeat;
    }
    .icon-lock{
        background: url(./assets/img/icon_lock.png) right 2px/12px no-repeat;
    }
    .icon-warn{
        background: url(./assets/img/icon_warn.png) right 2px/12px no-repeat;
    }
    .icon-projectMark{
        background: url(./assets/img/ico_projectMark.png) right 2px/12px no-repeat;
    }
    .icon-projectMark2{
        background: url(./assets/img/ico_projectMark2.png) right 2px/12px no-repeat;
    }
    .arrow-down{
        width: 10px;
        height: 6px;
        display: inline-block;
        background:url(./assets/img/icon_arrow2.png) center/100% no-repeat;
        transition: transform .2s ease;
    }
    .rotate90{
        transform: rotate(90deg);
    }
    .item-detail-wrapper{
        width: 100%;
        background-color: #eee;
        transition: all .3s ease;
        overflow: hidden;
        clear: both;
    }
    .item-detail {
        font-size: 13px;
        margin: 10px 1em;
    }
    .detail-left{
        width: 40%;
        display: inline-block;
        text-align: left;
    }
    .detail-right{
        width: 58%;
        display: inline-block;
        text-align: right;
    }
    /* end of list style */
    /* common card */
    .mint-navbar{
        overflow: hidden;
    }
    .mint-navbar .mint-tab-item {
        padding: 10px 0;
    }
    .is-selected .mint-tab-item-label:before{
        content: '——';
        position: absolute;
        /*border-bottom: 1px solid #3dcd57;*/
        transform: translate(50%,  10px);
    }
    .fixed-bottom{
        position: fixed;
        bottom: 0;
        left: 0;
        right:0;
        width: 100%;
        line-height: 50px;
        flex-wrap: wrap;
        font-size: 15px;
        display: flex;
        justify-content: space-between;
        /*padding:10px;*/
    }
    .fixed-bottom>button{
        flex: 1;
        line-height: 44px;
        margin: 5px;
        border-radius: 5px;
    }
    .detail-content{
        overflow-x: hidden;
        overflow-y: auto;
    }
    .common-card{
        overflow: auto;
        background: white;
        margin-bottom: 10px;
    }
    .common-card .common-title{
        background-color: #effff2;
        line-height: 44px;
        font-size: 15px;
        text-align: center;
    }
    .common-card .common-content{
        padding: 10px 1em;
        overflow: hidden;
    }
    .common-card .common-title.single-title{
        background-color: white;
        text-align: left;
        padding: 0 10px;
    }
    .common-card .common-content.as-table{
        display: table;
        width: 100%;
    }
    .common-content.expandable{
        padding: 0;
    }
    .common-content.expandable .table-row{
        padding: 10px;
    }
    .table-no-data{
        text-align: center;
        padding: 20px;
    }
    .detail-item{
        float: left;
        width: 100%;
        line-height: 20px;
        font-size: 12px;
        color: #666;
    }
    .detail-item input[type="text"],
    .detail-item textarea{
        border:1px solid #eee;
        border-radius: 5px;
        line-height: 30px;
        color: #333;
        width: 100%;
        margin: 5px 0;
        padding: 0 10px;
        resize: none;
    }
    input[readonly],
    textarea[readonly]{
        -webkit-user-select:none;
        ime-mode:disabled;
        -webkit-touch-callout:none;
    }
    .detail-item input[type="text"]::-webkit-input-placeholder,
    .detail-item textarea::-webkit-input-placeholder { /* WebKit browsers */
        color: #666;
    }
    .detail-item.left{
        width: 50%;
        padding-right: 10px;
    }
    .detail-item.right{
        width: 50%;
    }
    .common-content .detail-item:nth-of-type(odd){
        padding-right: 10px;
    }
    .text-green{
        color: #3dcd57;
    }
    .text-gray{
        color: #999;
    }
    .light-gray{
        color: #666;
    }
    .table-row{
        display: table-row;
        width: 100%;
    }
    .one3rd{
        width: 33.33%;
        display: table-cell;
        vertical-align: middle;
        padding: 10px;
    }
    /* .common-checklist{

    } */
    .common-checklist-item{
        font-size: 15px;
        line-height: 1;
        padding: 1.1em 1em 1em 3em;
        border-bottom: 1px solid #e8e8e8;
        background-color: #fff;
        position: relative;
    }
    .common-checklist-item .mint-checkbox-core{
        position: absolute;
        left: 20px;
        top: 15px;
        border: 1px solid #3dcd57;
    }
    /*
    *  checkbox checked style
    */
    label.active{
        color: #3dcd57;
    }
    .active .mint-checkbox-core{
        background-color: #3dcd57;
        border-color: #3dcd57;
    }
    .active .mint-checkbox-core::after {
        border-color: #fff;
        -webkit-transform: rotate(45deg) scale(1);
        transform: rotate(45deg) scale(1);
    }
    /* end of common card */
    /* flex table */
    .flex-table{
        background-color: #eee;
    }
    .flex-row{
        display: flex;
        justify-content: space-between;
        padding: 4px 1em;
        font-size: 13px;
        line-height: 40px;
        height: 48px;
        background-color: #fff;
    }
    .flex-item{
        flex-grow: 1;
        flex-basis:33.33%;
        align-self: center;
        line-height: 20px;
        display: -webkit-box;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-line-clamp: 2;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /*! autoprefixer: off */
    }
    .flex-table .flex-row{
        border-bottom: 1px solid #e8e8e8;
    }
    .flex-row .flex-item:nth-of-type(2){
        text-align: left;
    }
    .flex-row .flex-item:nth-of-type(3){
        text-align: right;
    }
    .light {
        display:inline-block;
        width: 18px;
        height:18px;
    }
    .light-1{
        background: url('data:image/svg+xml,<svg width="12" height="12" version="1.1" xmlns="http://www.w3.org/2000/svg"><circle cx="6" cy="6" r="5" fill="#ec4747"/></svg>') center no-repeat;
    }
    .light-2{
        background: url('data:image/svg+xml,<svg width="12" height="12" version="1.1" xmlns="http://www.w3.org/2000/svg"><circle cx="6" cy="6" r="5" fill="#f9a80d"/></svg>') center no-repeat;
    }
    .light-3{
        background: url('data:image/svg+xml,<svg width="12" height="12" version="1.1" xmlns="http://www.w3.org/2000/svg"><circle cx="6" cy="6" r="5" fill="#3dcd57"/></svg>') center no-repeat;
    }
    /* end of flex table */
    .radio{
        padding-left: 20px;
        background: url(./assets/img/icon_off.png) left center/14px no-repeat;
    }
    .radio.on{
        background: url(./assets/img/icon_on.png) left center/14px no-repeat;
    }

</style>



// WEBPACK FOOTER //
// Err.vue?1feaaf02